









































import { Component, Mixins } from 'vue-property-decorator';
import { MortgageMixin } from './MortgageMixin';
import ScrollLine, { ScrollLineItem } from '@/components/ScrollLine';
import SvgIcon from '@/components/SvgIcon';
import MortgageCard from './MortgageCard.vue';

@Component({
    components: {
        ScrollLine,
        ScrollLineItem,
        SvgIcon,
        MortgageCard,
    },
})
export default class MortgageInOwnPage extends Mixins(MortgageMixin) {}
